export const iconFontAwesomeCodingCube = (
	<i className="fa-solid fa-cube"></i>
);
